// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chameleon .edit_icon{margin-left:0;transform:unset}`, "",{"version":3,"sources":["webpack://./chameleon/legacy/src/components/questionBank/editor/LearnositySharedPassage.scss"],"names":[],"mappings":"AAAA,sBACE,aAAA,CACA,eAAA","sourcesContent":[".edit_icon {\n  margin-left: 0;\n  transform: unset;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
